import { intersection, compact } from 'lodash';
export var linkedMatchesFilter = function (linkedValues, filterValues) {
  // if no filter values, implicitly match
  if (!filterValues.length) return true;
  return intersection(filterValues, compact((linkedValues || []).map(function (e) {
    return e === null || e === void 0 ? void 0 : e.slug;
  }))).length > 0;
};